import { appConfig } from '../../../../../../../../../config/customization';
import { defaultPaddingLeft, mobileDefaultPaddingLeft } from '../../../../../../../../../constants/sizes';
import Device from '../../../../../../../../../constants/deviceSizes';

const container = {
  display: 'flex',
  padding: `10px ${defaultPaddingLeft}px`,
  maxWidth: '95%',
  [Device.mobile]: {
    flexDirection: 'column',
    alignItems: 'flex-start',
    padding: `10px ${mobileDefaultPaddingLeft}px`,
    maxWidth: '100%'
  }
};

const adherenceContainer = {
  display: 'flex',
  alignItems: 'center',
  width: '30%',
  [Device.mobile]: {
    justifyContent: 'space-between',
    width: '100%'
  }
};

const LINE_WIDTH = 1;

export default {
  expContainer: {
    ...container,
    justifyContent: 'space-between'
  },
  redContainer: {
    ...container,
    justifyContent: 'space-between'
  },
  line: {
    boxSizing: 'border-box',
    height: 40,
    width: LINE_WIDTH,
    backgroundColor: appConfig.colors.bordersGray,
    flexShrink: 0,
    [Device.mobile]: {
      width: '100%',
      height: LINE_WIDTH,
      margin: '5px 0px'
    }
  },
  title: {
    marginTop: 2
  },
  middleAdherenceContainer: {
    ...adherenceContainer,
    justifyContent: 'center'
  },
  lastAdherenceContainer: {
    ...adherenceContainer,
    justifyContent: 'flex-end',
    [Device.mobile]: {
      width: '100%',
      justifyContent: appConfig.accountStatus.digitalBillButtonWithTitle ? 'flex-end' : 'space-between'
    }
  }
};
